export default __webpack_public_path__ + "static/media/gentamycin1.06d49175.png";